import { StyleSheet } from 'aphrodite';
import { typography } from 'util/styleUtil';
import images from 'constants/images/dtOneImages';

const getSkin = (theme) => {
	const globalProfiles = theme.get('globalProfiles');
	const skin = globalProfiles.get('palette');
	const myTypography = typography(theme);

	return StyleSheet.create({
		popupContainer: {
			// backgroundColor: skin.get('grayColor4')
		},
		popupBackground: {
			backgroundColor: skin.get('grayColor4')
		}
	});
}

export default getSkin;